<template>
  <div>
    <template v-if="type_menu == 'Initial_Menu'">
      <template v-if="ItemObj.has_children">
        <!-- If show_children is false, show collapsible inline children -->
        <template v-if="ItemObj.show_children === false">
          <div class="d-flex flex-column align-start cls_pointer pb-4">
            <div class="d-flex align-center" :class="[is_disabled_class, isSelected ? is__bp_color : '']" style="gap: 8px;" @click="is_screen_RightsHide ? toggleChildren() : openAccessDialog(ItemObj)">
              <img v-if="coloredSvg" :src="coloredSvg" width="18" height="18" :class="is_disabled_class" style="flex-shrink: 0;" />
              <v-icon v-else-if="isMdiIcon(ItemObj.icon)" size="18" :class="is_disabled_class" style="flex-shrink: 0;" :color="default_Svg_Fill">{{ ItemObj.icon }}</v-icon>
              <img v-else-if="ItemObj.icon"
                :src="isAnyChildSelected(ItemObj) && ItemObj.blue_icon ? ItemObj.blue_icon : ItemObj.icon" width="18"
                height="18" style="flex-shrink: 0;" />
              <span style="font-size: 13px; display: flex; align-items: center;" v-html="Menu_Name_Shown"></span>
              <v-icon size="20" style="transition: transform 0.3s;">{{ childrenExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </div>
            <div v-if="childrenExpanded" class="pl-6 sub_list_txt" style="width: 100%;">
              <div v-for="(item, i) in ItemObj.children" :key="i" class="pl-3 my-3 d-flex align-center">
                <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
                  :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                  :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="item"
                  type_menu="Children_Menu" @to_close_MenuDialog="to_close_MenuDialog" />
              </div>
            </div>
          </div>
        </template>
        <!-- Two-column layout for children (e.g. Activate → Process Design | Management Systems) -->
        <template v-else-if="ItemObj.twoColumnChildren">
          <div class="d-flex flex-column align-start">
            <div class="heading_of_txt_icon d-flex align-center justify-center cls_pointer" :class="is_disabled_class" style="margin-bottom: 0px; width: 100%;" @click="!is_screen_RightsHide ? openAccessDialog(ItemObj) : null">
              <img v-if="coloredSvg" :src="coloredSvg" width="18" height="18" :class="is_disabled_class" />
              <v-icon v-else-if="isMdiIcon(ItemObj.icon)" size="18" :class="is_disabled_class" :color="default_Svg_Fill">{{ ItemObj.icon }}</v-icon>
              <img v-else-if="ItemObj.icon"
                :src="isAnyChildSelected(ItemObj) && ItemObj.blue_icon ? ItemObj.blue_icon : ItemObj.icon" width="18"
                height="18" />
              <span class="pl-3" style="font-size: 13px" v-html="Menu_Name_Shown"></span>
            </div>
            <div style="display: flex; gap: 32px; align-items: flex-start; margin-top: 8px; justify-content: center;">
              <div v-for="(item, i) in ItemObj.children" :key="i" class="sub_list_txt" style="min-width: 140px;">
                <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
                  :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                  :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="item"
                  type_menu="Children_Menu" @to_close_MenuDialog="to_close_MenuDialog" />
              </div>
            </div>
          </div>
        </template>
        <!-- Otherwise show children directly (expanded by default) -->
        <template v-else>
          <div class="d-flex flex-column align-start">
            <div class="heading_of_txt_icon d-flex justify-center align-center cls_pointer" :class="is_disabled_class" @click="!is_screen_RightsHide ? openAccessDialog(ItemObj) : null">
              <img v-if="coloredSvg" :src="coloredSvg" width="18" height="18" :class="is_disabled_class" />
              <v-icon v-else-if="isMdiIcon(ItemObj.icon)" size="18" :class="is_disabled_class" :color="default_Svg_Fill">{{ ItemObj.icon }}</v-icon>
              <img v-else-if="ItemObj.icon"
                :src="isAnyChildSelected(ItemObj) && ItemObj.blue_icon ? ItemObj.blue_icon : ItemObj.icon" width="18"
                height="18" />
              <span class="pl-3" style="font-size: 13px" v-html="Menu_Name_Shown"></span>
            </div>
            <div class="pl-3 sub_list_txt">
              <div v-for="(item, i) in ItemObj.children" :key="i" class="pl-3 my-3 d-flex align-center">
                <!-- class="pl-3 my-3 d-flex align-center" -->
                <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
                  :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                  :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="item"
                  type_menu="Children_Menu" @to_close_MenuDialog="to_close_MenuDialog" />
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
          :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page" :is__granules_page="is__granules_page"
          :is__emami_page="is__emami_page" :ItemObj="ItemObj" type_menu="Item_List_Menu"
          @to_close_MenuDialog="to_close_MenuDialog" />
      </template>
    </template>

    <template v-if="type_menu == 'Children_Menu'">
      <!-- Accordion style - expands inline (exclusive - only one open at a time) -->
      <template v-if="ItemObj.has_children && ItemObj.isAccordion">
        <div style="width: 100%;">
          <div class="d-flex align-center py-1" :class="[is_disabled_class, isSelected ? is__bp_color : '']">
            <span class="pl-1 sub_list_txt" style="font-size: 11px; font-weight: 600; color: #7E8299; text-transform: uppercase; letter-spacing: 0.5px;" v-html="Menu_Name_Shown"></span>
          </div>
          <div class="pl-3">
            <template v-for="(child, i) in ItemObj.children">
              <div :key="'acc-child-' + i" class="d-flex align-center" style="padding: 4px 0;">
                <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
                  :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page" :is__granules_page="is__granules_page"
                  :is__emami_page="is__emami_page" :ItemObj="child" :type_menu="child.has_children ? 'Children_Menu' : 'Item_List_Menu_NoICoN'"
                  @to_close_MenuDialog="to_close_MenuDialog" />
              </div>
            </template>
          </div>
        </div>
      </template>
      <!-- Regular submenu with popup -->
      <template v-else-if="ItemObj.has_children">
        <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
          :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page" :is__granules_page="is__granules_page"
          :is__emami_page="is__emami_page" :ItemObj="ItemObj" type_menu="Children_Initial_Menu"
          @to_close_MenuDialog="to_close_MenuDialog" />
      </template>
      <template v-else>
        <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
          :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page" :is__granules_page="is__granules_page"
          :is__emami_page="is__emami_page" :ItemObj="ItemObj" type_menu="Item_List_Menu_NoICoN"
          @to_close_MenuDialog="to_close_MenuDialog" />
      </template>
    </template>

    <template v-if="type_menu == 'Children_Initial_Menu'">
      <div class="pt-1 sub_list_txt d-flex justify-center align-center cls_pointer">
        <v-menu offset-x :nudge-left="12" :nudge-bottom="20" v-model="menu_model" :close-on-content-click="false" :disabled="!is_screen_RightsHide">
          <template v-slot:activator="{ on, attrs }">
            <div @click="is_screen_RightsHide ? (menu_model = !menu_model) : openAccessDialog(ItemObj)" :class="[is_disabled_class, isSelected ? is__bp_color : '']">
              <span :class="['menu-dot', { active: isSelected }]"></span>
              <span class="pl-3" style="font-size: 13px" v-html="Menu_Name_Shown"></span>
              <v-icon size="20">mdi-chevron-down</v-icon>
            </div>
          </template>
          <v-card style="max-height: 400px; overflow-y: auto;">
            <v-list dense>
              <template v-for="(child, i) in ItemObj.children">
                <template v-if="child.has_children && child.isAccordion">
                  <!-- Accordion inline expansion -->
                  <div :key="'accordion-' + i" style="width: 100%;">
                    <v-list-item @click="$set(accordionStates, child.id, !accordionStates[child.id])" class="flex__remove py-1">
                      <v-list-item-title class="sub_list_txt d-flex align-center justify-space-between">
                        <span>{{ child.name }}</span>
                        <v-icon size="18">{{ accordionStates[child.id] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </v-list-item-title>
                    </v-list-item>
                    <div v-if="accordionStates[child.id]" class="pl-4">
                      <template v-for="(subChild, j) in child.children">
                        <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page"
                          :is__gmr_page="is__gmr_page" :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                          :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="subChild"
                          type_menu="Menu_Item_List_Menu_NoICoN" @to_close_MenuDialog="to_close_MenuDialog" :key="'sub-' + j" />
                      </template>
                    </div>
                  </div>
                </template>
                <template v-else-if="child.has_children">
                  <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page"
                    :is__gmr_page="is__gmr_page" :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                    :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="child"
                    type_menu="Another_Children_Initial_Menu" @to_close_MenuDialog="to_close_MenuDialog" :key="'child-' + i" />
                </template>
                <template v-else>
                  <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page"
                    :is__gmr_page="is__gmr_page" :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                    :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="child"
                    type_menu="Menu_Item_List_Menu_NoICoN" @to_close_MenuDialog="to_close_MenuDialog" :key="'item-' + i" />
                </template>
              </template>
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </template>

    <template v-if="type_menu == 'Children_Initial_Menu_Side'">
      <v-menu offset-x :nudge-left="12" v-model="menu_model" :disabled="!is_screen_RightsHide">
        <template v-slot:activator="{ on, attrs }">
          <div @click="is_screen_RightsHide ? (menu_model = !menu_model) : openAccessDialog(ItemObj)" :class="[is_disabled_class, isSelected ? is__bp_color : '']">
            <v-list-item-icon class="d-flex align-center">
              <v-icon class="pl-0" dense v-if="ItemObj.adani_icon" :color="default_Svg_Fill">{{ ItemObj.adani_icon }}</v-icon>
              <img v-else-if="coloredSvg" :src="coloredSvg" width="18" height="18" />
              <v-icon v-else-if="isMdiIcon(ItemObj.icon)" size="18" :color="default_Svg_Fill">{{ ItemObj.icon }}</v-icon>
              <img v-else-if="ItemObj.icon"
                :src="isAnyChildSelected(ItemObj) && ItemObj.blue_icon ? ItemObj.blue_icon : ItemObj.icon" width="18"
                height="18" />
            </v-list-item-icon>
          </div>
        </template>
        <v-card min-width="200" style="max-height: 80vh; overflow-y: auto;">
          <v-list dense class="py-2">
            <!-- Parent Name Header - Left aligned, Bold -->
            <v-list-item class="mb-1">
              <v-list-item-title class="font-weight-bold" style="font-size: 14px; color: #181C32;">
                {{ ItemObj.name }}
              </v-list-item-title>
            </v-list-item>
            <!-- Children List -->
            <template v-for="(child, i) in ItemObj.children">
              <template v-if="child.has_children">
                <SideBarMenu :key="i" :is_board_page="is_board_page" :is__adani_page="is__adani_page"
                  :is__gmr_page="is__gmr_page" :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                  :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="child"
                  type_menu="Another_Children_Initial_Menu" @to_close_MenuDialog="to_close_MenuDialog" />
              </template>
              <template v-else>
                <v-list-item :key="i" :to="child.to" @click="to_close_MenuDialog" class="pl-4 sidebar-menu-item" :class="sidebarSelectedClass">
                  <span class="sidebar-menu-dot mr-2" :class="{ 'sidebar-menu-dot-active': $route.path === child.to }"></span>
                  <span class="sidebar-menu-text-wrapper">
                    <span class="sub_list_txt" :class="{ 'sidebar-menu-child-selected': $route.path === child.to }" style="font-size: 13px;" :title="child.title || ''">
                      {{ child.name }}
                    </span>
                  </span>
                </v-list-item>
              </template>
            </template>
          </v-list>
        </v-card>
      </v-menu>
    </template>

    <template v-if="type_menu == 'Another_Children_Initial_Menu'">
      <!-- Accordion style inline dropdown -->
      <template v-if="ItemObj.isAccordion">
        <div style="width: 100%;">
          <v-list-item @click="is_screen_RightsHide ? (childrenExpanded = !childrenExpanded) : openAccessDialog(ItemObj)" :class="[is_disabled_class, isSelected ? is__bp_color : '']" class="flex__remove py-1">
            <v-list-item-title class="sub_list_txt d-flex align-center justify-space-between" :class="isSelected ? is__bp_color : ''">
              <span v-html="Menu_Name_Shown"></span>
              <v-icon size="18">{{ childrenExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-list-item-title>
          </v-list-item>
          <div v-if="childrenExpanded" class="pl-4">
            <template v-for="(child, i) in ItemObj.children">
              <template v-if="child.has_children">
                <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
                  :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                  :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="child"
                  type_menu="Another_Children_Initial_Menu" @to_close_MenuDialog="to_close_MenuDialog" :key="'nested-' + i" />
              </template>
              <template v-else>
                <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
                  :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                  :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="child"
                  type_menu="Menu_Item_List_Menu_NoICoN" @to_close_MenuDialog="to_close_MenuDialog" :key="'child-' + i" />
              </template>
            </template>
          </div>
        </div>
      </template>
      <!-- Default popup submenu -->
      <template v-else>
        <v-menu offset-x :nudge-right="10" :disabled="!is_screen_RightsHide">
          <template #activator="{ on, attrs }">
            <v-list-item v-bind="attrs" v-on="is_screen_RightsHide ? on : {}" @click="!is_screen_RightsHide ? openAccessDialog(ItemObj) : null" :class="[is_disabled_class, isSelected ? is__bp_color : '']">
              <v-list-item-title class="sub_list_txt" :class="isSelected ? is__bp_color : ''"
                v-html="Menu_Name_Shown"></v-list-item-title>
              <v-icon right>mdi-chevron-right</v-icon>
            </v-list-item>
          </template>

          <v-list dense>
            <template v-for="(child, i) in ItemObj.children">
              <template v-if="child.has_children">
                <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
                  :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                  :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="child"
                  type_menu="Another_Children_Initial_Menu" @to_close_MenuDialog="to_close_MenuDialog" />
              </template>
              <template v-else>
                <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
                  :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                  :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="child"
                  type_menu="Menu_Item_List_Menu_NoICoN" @to_close_MenuDialog="to_close_MenuDialog" />
              </template>
            </template>
          </v-list>
        </v-menu>
      </template>
    </template>

    <template v-if="type_menu == 'Menu_Item_List_Menu_NoICoN'">
      <section class="left_common_Opacity d-flex align-center">
        <span :class="['menu-dot', { active: isSelected }]"></span>
        <v-list-item :to="is_screen_RightsHide ? ItemObj.to : undefined" @click="is_screen_RightsHide ? handleMenuSelect($event, ItemObj) : openAccessDialog(ItemObj)"
          :class="[is_disabled_class, { [is__bp_color]: isSelected }]" class="flex__remove pl-2">
          <v-list-item-title class="sub_list_txt _menu_list__text" :class="{ [is__bp_color]: isSelected }"
            v-html="Menu_Name_Shown"></v-list-item-title>
        </v-list-item>
      </section>
    </template>

    <template v-if="type_menu == 'Menu_Item_List_Menu_ICoN'">
      <v-list-item :class="is_disabled_class" :to="is_screen_RightsHide ? ItemObj.to : undefined" :active-class="is__bp_color" class="" aria-current="page"
        @click="is_screen_RightsHide ? clickTo($event, ItemObj) : openAccessDialog(ItemObj)">
        <v-icon class="pl-0" dense v-if="ItemObj.adani_icon" :color="default_Svg_Fill">{{ ItemObj.adani_icon }}</v-icon>
        <img v-else-if="coloredSvg" :src="coloredSvg" width="18" height="18" class="_menu_list__icon" />
        <v-icon v-else-if="isMdiIcon(ItemObj.icon)" size="18" :color="default_Svg_Fill">{{ ItemObj.icon }}</v-icon>
        <img v-else-if="ItemObj.icon" :src="ItemObj.icon" width="18" height="18" />
      </v-list-item>
    </template>

    <template v-if="type_menu == 'Item_List_Menu_NoICoN'">
      <section class="left_common_Opacity d-flex align-center">
        <span :class="['menu-dot', { active: isSelected }]"></span>
        <v-list-item :to="is_screen_RightsHide ? ItemObj.to : undefined" class="py-1 pl-3 list_min_heigt_common sub_list_txt"
          @click="is_screen_RightsHide ? handleMenuSelect($event, ItemObj) : openAccessDialog(ItemObj)"
          :class="[is_disabled_class, { [is__bp_color]: isSelected }]" :active-class="is__bp_color">
          <v-list-item-title class="sub_list_txt _menu_list__text" :class="{ [is__bp_color]: isSelected }"
            v-html="Menu_Name_Shown"></v-list-item-title>
        </v-list-item>
      </section>
    </template>

    <template v-if="type_menu == 'Item_List_Menu'">
      <v-list-item :to="is_screen_RightsHide ? ItemObj.to : undefined" class="py-1 list_min_heigt_common sub_list_txt"
        @click="is_screen_RightsHide ? handleMenuSelect($event, ItemObj) : openAccessDialog(ItemObj)"
        :class="[is_disabled_class, { [is__bp_color]: isSelected }]">
        <v-icon v-if="isMdiIcon(ItemObj.icon)" size="18" :color="default_Svg_Fill">{{ ItemObj.icon }}</v-icon>
        <img v-else-if="ItemObj.icon" :src="ItemObj.icon" width="18" height="18" />
        <span v-if="ItemObj.id && !is_disabled_class" :class="['menu-dot', { active: isSelected }]"></span>
        <v-list-item-title class="sub_list_txt _menu_list__text" :class="{ [is__bp_color]: isSelected }"
          v-html="Menu_Name_Shown"></v-list-item-title>
      </v-list-item>
    </template>

    <template v-if="type_menu == 'Item_List_Menu_LEFTSide'">
      <section class="left_common_Opacity pb-4" :class="is_disabled_class">
        <v-list-item :to="is_screen_RightsHide ? ItemObj.to : undefined" :active-class="is__bp_color" class="pa-0  list_min_heigt_common _menu_list"
          aria-current="page" @click="is_screen_RightsHide ? clickTo($event, ItemObj) : openAccessDialog(ItemObj)">

          <img v-if="coloredSvg" :src="coloredSvg" width="18" height="18" class="_menu_list__icon" />
          <v-icon v-else-if="isMdiIcon(ItemObj.icon)" size="18" class="_menu_list__icon" :color="default_Svg_Fill">{{ ItemObj.icon }}</v-icon>
          <img v-else-if="ItemObj.icon" :src="ItemObj.icon" width="18" height="18" class="_menu_list__icon" />
          <span class="pl-2 _menu_list__text" v-html="Menu_Name_Shown"></span>
        </v-list-item>
      </section>
    </template>

    <!-- Access Request Dialog -->
    <v-dialog v-model="accessDialog" max-width="420" persistent>
      <v-card style="border-radius: 12px; overflow: hidden;">
        <div style="background: linear-gradient(135deg, #3B4CC0, #6C4ED9); padding: 20px 24px 16px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <v-icon color="white" size="22">mdi-lock-outline</v-icon>
            <span style="color: white; font-size: 15px; font-weight: 600; font-family: Poppins;">Access Required</span>
          </div>
          <div style="color: rgba(255,255,255,0.75); font-size: 12px; margin-top: 4px; font-family: Poppins;">
            {{ accessDialogItem ? accessDialogItem.name : '' }}
          </div>
        </div>
        <v-card-text style="padding: 20px 24px 12px;">
          <div style="font-size: 13px; color: #3F4254; font-family: Poppins; line-height: 1.6;">
            You don't have access to <strong>{{ accessDialogItem ? accessDialogItem.name : 'this module' }}</strong>.
            Please contact your administrator to enable this module for your role.
          </div>
          <div style="background: #F5F4FA; border-radius: 8px; padding: 12px 14px; margin-top: 14px;">
            <div style="font-size: 10px; font-weight: 600; color: #9A96A8; font-family: Poppins; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 8px;">Contact Your Administrator</div>
            <div v-if="adminUsersLoading" style="font-size: 12px; color: #9A96A8; font-family: Poppins;">Loading admin details...</div>
            <div v-else-if="adminUsers.length" style="display: flex; flex-direction: column; gap: 10px;">
              <div v-for="(admin, i) in adminUsers" :key="i" style="display: flex; flex-direction: column; gap: 4px; padding-bottom: 8px; border-bottom: 1px solid #E6E4EE;" v-show="i < adminUsers.length - 1 || adminUsers.length === 1 ? true : true">
                <div style="display: flex; align-items: center; gap: 8px; font-size: 12px; color: #5A5A72; font-family: Poppins;">
                  <v-icon size="14" color="#3B4CC0">mdi-account-outline</v-icon>
                  <span style="font-weight: 600;">{{ admin.name }}</span>
                </div>
                <div v-if="admin.email" style="display: flex; align-items: center; gap: 8px; font-size: 12px; color: #5A5A72; font-family: Poppins;">
                  <v-icon size="14" color="#3B4CC0">mdi-email-outline</v-icon>
                  <span>{{ admin.email }}</span>
                </div>
              </div>
            </div>
            <div v-else style="font-size: 12px; color: #9A96A8; font-family: Poppins;">No admin contact found. Please reach out to your system administrator.</div>
          </div>
          <div style="font-size: 11px; color: #9A96A8; margin-top: 12px; font-family: Poppins;">
            Contact your admin to request access to <strong>{{ accessDialogItem ? accessDialogItem.name : 'this module' }}</strong>.
          </div>
        </v-card-text>
        <v-card-actions style="padding: 8px 24px 20px; gap: 8px; justify-content: flex-end;">
          <v-btn text style="font-size: 12px; color: #9A96A8; font-family: Poppins; text-transform: none;" @click="accessDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SideBarMenu from "@/components/Menu/SideBarMenu.vue";

const GlobalMenuState = {
  selectedMenuId: null,
  openAccordions: {},
  toggledAccordions: {},
  setSelectedMenu(menuId) {
    this.selectedMenuId = menuId;
  },
  getSelectedMenu() {
    return this.selectedMenuId;
  },
  setActiveAccordion(accordionId) {
    // Toggle: open/close individual accordion (multiple can be open)
    this.toggledAccordions[accordionId] = true;
    if (this.openAccordions[accordionId]) {
      delete this.openAccordions[accordionId];
    } else {
      this.openAccordions[accordionId] = true;
    }
  },
  isAccordionOpen(accordionId) {
    // Default open if not yet toggled
    if (!this.toggledAccordions[accordionId]) return true;
    return !!this.openAccordions[accordionId];
  }
};

export default {
  name: "SideBarMenu",
  props: {
    ItemObj: {
      type: Object,
      default: {},
    },
    type_menu: {
      type: String,
      default: null,
    },
    is_board_page: {
      type: Boolean,
      default: false,
    },
    is__adani_page: {
      type: Boolean,
      default: false,
    },
    is__gmr_page: {
      type: Boolean,
      default: false,
    },

    is__vardhman_page: {
      type: Boolean,
      default: false,
    },

    is__parle_page: {
      type: Boolean,
      default: false,
    },

    is__granules_page: {
      type: Boolean,
      default: false,
    },

    is__emami_page: {
      type: Boolean,
      default: false,
    },


  },
  components: {
    SideBarMenu,
  },
  data() {
    return {
      menu_model: false,
      globalMenuState: GlobalMenuState,
      childrenExpanded: false,
      accordionStates: {},
      accessDialog: false,
      accessDialogItem: null,
      adminUsers: [],
      adminUsersLoading: false,
    };
  },
  computed: {
    is__bp__adani_color() {

      if (this.is__adani_page == true) {
        return '_menu_list_color_ADANI';
      } else if (this.is__gmr_page == true) {
        return '_menu_list_color_GMR';
      }
      else if (this.is__vardhman_page == true) {
        return '_menu_list_color_VARDHMAN';
      }
      else if (this.is__parle_page == true) {
        return '_menu_list_color_PARLE';
      } else if (this.is__granules_page == true) {
        return '_menu_list_color_GRANULES';
      } else if (this.is__emami_page == true) {
        return '_menu_list_color_EMAMI';
      } else {
        return '_menu_list_color_orange';
      }

    },

    is__bp_color() {
      // Check if logged in from family book
      const isFamilyBook = localStorage.getItem("is_family_book") === "true";

      if (isFamilyBook) {
        return '_menu_list_color_familybook';
      }

      return this.is_board_page ? this.is__bp__adani_color : '_menu_list_color_blue';
    },
    first_cls() {
      return this.is_board_page ? "cls_font_18_bols" : "cls_font_18_bols";
    },
    is_screen_RightsHide() {
      return this.checkproductvalue(this.ItemObj);
    },
    is_disabled_class() {
      return !this.is_screen_RightsHide ? "module-locked" : "";
    },
    Menu_Name_Shown() {
      return this.highlightFirst(
        this.ItemObj.name,
        this.ItemObj.is_FirstLetter
      );
    },
    isSelected() {
      return this.isParentSelected ? true : this.$route.path === this.ItemObj.to;
    },
    isParentSelected() {
      return this.ItemObj.is___select ? true : false;
    },
    is_ADANAI_clr() {
      // return this.is__adani_page ? '#6C4ED9' : '#FF9500';
      return this.is__adani_page ? '#0B74B0' : '#FF9500';
    },
    is_board_clr() {
      // Check if logged in from family book
      const isFamilyBook = localStorage.getItem("is_family_book") === "true";

      if (isFamilyBook) {
        return '#3706ff';
      }

      return this.is_board_page ? this.is_ADANAI_clr : '#3706ff';
    },
    default_Svg_Fill() {
      return this.isSelected ? this.is_board_clr : '#7E8299'
    },
    coloredSvg() {
      const encoded = this.ItemObj.svg_icon ? encodeURIComponent(this.ItemObj.svg_icon.replace(/__FLLL_Color__/g, this.default_Svg_Fill)) : null;
      return encoded ? `data:image/svg+xml;utf8,${encoded}` : null;
    },
    sidebarSelectedClass() {
      const isFamilyBook = localStorage.getItem("is_family_book") === "true";
      if (isFamilyBook) {
        return 'sidebar-selected-familybook';
      }
      return this.is_board_page ? 'sidebar-selected-board' : 'sidebar-selected-starr';
    },
    localStorage_username() {
      return localStorage.getItem("USER_NAME") || "";
    },
    localStorage_email() {
      return localStorage.getItem("USER_EMAIL") || "";
    },
  },
  mounted() {
    if (this.ItemObj.to == '/BoardDashBoard') {
      // console.log(this.ItemObj.svg_icon, "ItemObj mounted");
    }
    // Set body theme class for popup menu hover styles
    this.setBodyThemeClass();
  },
  methods: {
    isMdiIcon(icon) {
      return typeof icon === 'string' && icon.startsWith('mdi-');
    },
    setBodyThemeClass() {
      // Remove existing theme classes
      document.body.classList.remove('starr-theme', 'board-theme', 'familybook-theme');

      // Check if logged in from family book
      const isFamilyBook = localStorage.getItem("is_family_book") === "true";

      if (isFamilyBook) {
        document.body.classList.add('familybook-theme');
      } else if (this.is_board_page) {
        document.body.classList.add('board-theme');
      } else {
        document.body.classList.add('starr-theme');
      }
    },
    toggleChildren() {
      this.childrenExpanded = !this.childrenExpanded;
    },
    to_close_MenuDialog() {
      this.$emit("to_close_MenuDialog");
      this.menu_model = false;
    },
    clickTo(event, ItemObj = {}) {
      if (event.ctrlKey || event.metaKey) {

      } else {
        this.to_close_MenuDialog();
        this.menu_model = false;
      }
    },
    handleMenuSelect($event, ItemObj = {}) {
      // Set the global selected menu
      this.globalMenuState.setSelectedMenu(ItemObj.to);
      this.clickTo($event, ItemObj);
    },
    openAccessDialog(item) {
      this.accessDialogItem = item;
      this.accessDialog = true;
      if (!this.adminUsers.length && !this.adminUsersLoading) {
        this.fetchAdminUsers();
      }
    },
    fetchAdminUsers() {
      const entityId = localStorage.getItem("ENTITY_ID");
      if (!entityId) return;
      this.adminUsersLoading = true;
      window.axios = require("axios");
      Promise.all([
        axios.get("roles?active=true&entity_id=" + entityId),
        axios.get("users?active=true&entity_id=" + entityId),
      ]).then(([rolesRes, usersRes]) => {
        const adminRoleIds = new Set(
          (rolesRes.data.data || []).filter(r => r.is_admin === true).map(r => r.id)
        );
        const adminUser = (usersRes.data.data || []).find(u => {
          const userRoles = Array.isArray(u.roles) ? u.roles : [];
          return userRoles.some(r => adminRoleIds.has(typeof r === 'object' ? r.id : r));
        });
        this.adminUsers = adminUser
          ? [{ name: adminUser.name || adminUser.user_name || "", email: adminUser.email || adminUser.user_email || "" }]
          : [];
      })
      .catch(() => {})
      .finally(() => { this.adminUsersLoading = false; });
    },
    highlightFirst(text, is_FirstLetter = false) {
      if (!text) return "";
      const firstChar = text.charAt(0);
      if (firstChar && is_FirstLetter) {
        if (!this.is_screen_RightsHide) {
          return `<span class="module-locked-text"><span class="${this.first_cls
            }">${firstChar}</span>${text.slice(1)}</span>`;
        } else {
          return `<span class="${this.first_cls
            }">${firstChar}</span>${text.slice(1)}`;
        }
      } else {
        if (!this.is_screen_RightsHide) {
          return `<span class="module-locked-text">${text}</span>`;
        } else {
          return text;
        }
      }
    },
    checkproductvalue(item) {
      var product_list = localStorage.getItem("tectalik_product_list");
      var domain = localStorage.getItem("domain");
      var features_list = localStorage.getItem("features_list");

      let module_rights_dataset = JSON.parse(
        localStorage.getItem("MODULE_RIGHTS_DATASET")
      );
      let screen_right_dataset = JSON.parse(
        localStorage.getItem("SCREEN_RIGHT_DATASET")
      );

      let common_screen_right_dataset = JSON.parse(
        localStorage.getItem("COMMON_SCREEN_RIGHT_DATASET")
      );

      let flags_module = 0;
      let flags_screen = 0;
      var flags = 0;
      var features_flags = 0;
      var product_code = item.product_code;
      var screen_code = item.screen_code;

      let module_codeflag = [];
      let screen_codeflag = [];
      if (item.module_codeflag) {
        module_codeflag = item.module_codeflag;
      }
      if (item.screen_codeflag) {
        screen_codeflag = item.screen_codeflag;
      }

      // Partner domain: show only partner-specific screens
      if (domain === "partner") {
        // Partner screens (SCN_PARTNER_*) are always visible for partner domain
        if (screen_codeflag.some(f => f.startsWith("SCN_PARTNER"))) {
          return true;
        }
        // For other items, check COMMON_SCREEN_RIGHT_DATASET (same as admin)
        let partner_flags = 0;
        if (
          common_screen_right_dataset != null &&
          common_screen_right_dataset != "" &&
          common_screen_right_dataset != undefined &&
          common_screen_right_dataset.length != 0
        ) {
          var filteredScreen = common_screen_right_dataset.filter(function (s) {
            return screen_codeflag.indexOf(s.screen_code) !== -1;
          });
          for (var i = 0; i < filteredScreen.length; i++) {
            if (filteredScreen[i].landing) {
              partner_flags++;
              break;
            }
          }
        }
        return partner_flags > 0;
      }

      let orolist = ["Customer_Target", "Customer_Report"];
      if (!["admin", "devadmin"].includes(domain)) {
        if (
          orolist.includes(item.name) &&
          domain != "oro" &&
          domain != "align"
        ) {
          return false;
        }

        if (item.product_only) {
          if (!product_list) return false;
          const pl = product_list.split ? product_list.split(",") : product_list;
          return product_code && product_code.length > 0
            ? product_code.some(pc => pl.includes(pc))
            : false;
        }

        if (item.isnonadmintoshow) {
          if (process.env.NODE_ENV === "production") {
            if (item.isproductiontohide) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          if (!item.iscommontoshow) {
            if (process.env.NODE_ENV === "production") {
              if (item.isproductiontohide) {
                return false;
              }
            }
            if (
              product_list != null &&
              product_list != "" &&
              product_list != undefined &&
              product_list.length != 0
            ) {
              product_list = product_list.split(",");
              if (
                product_code != null &&
                product_code != "" &&
                product_code != undefined &&
                product_code.length != 0
              ) {
                let idex = product_list.filter(function (item) {
                  return product_code.indexOf(item) !== -1;
                });
                if (idex.length !== 0) {
                  flags++;
                }
              }
            }
            if (
              module_rights_dataset != null &&
              module_rights_dataset != "" &&
              module_rights_dataset != undefined &&
              module_rights_dataset.length != 0
            ) {
              var filteredmoudule = module_rights_dataset.filter(function (
                item
              ) {
                return module_codeflag.indexOf(item.module_code) !== -1;
              });
              for (var i = 0; i < filteredmoudule.length; i++) {
                if (filteredmoudule[i].active) {
                  flags_module++;
                  break;
                }
              }
            }
            if (
              screen_right_dataset != null &&
              screen_right_dataset != "" &&
              screen_right_dataset != undefined &&
              screen_right_dataset.length != 0
            ) {
              var filteredScreen = screen_right_dataset.filter(function (item) {
                return screen_codeflag.indexOf(item.screen_code) !== -1;
              });
              for (var i = 0; i < filteredScreen.length; i++) {
                if (filteredScreen[i].landing) {
                  flags_screen++;
                  break;
                }
              }
            }
            if (flags_module > 0 && flags_screen > 0) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      } else {
        if (!item.iscommontoshow) {
          let flags_screen = 0;
          if (
            common_screen_right_dataset != null &&
            common_screen_right_dataset != "" &&
            common_screen_right_dataset != undefined &&
            common_screen_right_dataset.length != 0
          ) {
            var filteredScreen = common_screen_right_dataset.filter(function (
              item
            ) {
              return screen_codeflag.indexOf(item.screen_code) !== -1;
            });
            for (var i = 0; i < filteredScreen.length; i++) {
              if (filteredScreen[i].landing) {
                flags_screen++;
                break;
              }
            }
          }

          if (flags_screen > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    },
    isAnyChildSelected(ItemObj) {
      if (!ItemObj.children || !Array.isArray(ItemObj.children)) return false;
      return ItemObj.children.some(
        child =>
          this.globalMenuState.selectedMenuId === child.to ||
          (child.children && this.isAnyChildSelected(child))
      );
    },
  },
};
</script>

<style type="text/css" scoped>
.flex__remove>>>.v-list-item__title,
.v-list-item__subtitle {
  flex: none !important;
}

.left_common_Opacity>>>.theme--light.v-list-item--active:hover::before,
.left_common_Opacity>>>.theme--light.v-list-item--active::before {
  opacity: 0;
}

.list_min_heigt_common {
  min-height: 0px !important;
}

._menu_list_color_orange {
  color: #3F4254 !important;
}

._menu_list_color_orange ._menu_list__text {
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

._menu_list_color_blue {
  color: #3F4254 !important;
}

._menu_list_color_blue ._menu_list__text {
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

._menu_list_color_familybook {
  color: #3F4254 !important;
}

._menu_list_color_familybook ._menu_list__text {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

._menu_list_color_ADANI {
  /* color: #6C4ED9 !important; */
  color: linear-gradient(135deg, #0B74B0, #75479C, #BD3861) !important;
}


._menu_list_color_GMR {

  color: linear-gradient(135deg, #003974, #ed1c24, #faab53, #003974) !important;

}

._menu_list_color_VARDHMAN {

  color: linear-gradient(90deg, rgba(233, 237, 242, 1) 10%, rgba(5, 130, 59, 1) 34%) !important;

}

._menu_list_color_PARLE {
  color: linear-gradient(304deg, rgba(245, 235, 235, 1) 0%, rgba(245, 166, 166, 1) 30%, rgba(245, 70, 70, 1) 65%, rgba(245, 70, 70, 1) 16%, rgba(245, 70, 70, 1) 100%) !important;
}

._menu_list_color_GRANULES {
  color: linear-gradient(135deg, #0098da 0%, #6fb9d6 30%, #f68a74 70%, #ffffff 100%) !important;
}


._menu_list_color_EMAMI {
  color: linear-gradient(304deg,
      rgba(103, 57, 133, 1) 0%,
      rgba(75, 197, 228, 1) 25%,
      rgba(131, 201, 37, 1) 50%,
      rgba(252, 225, 2, 1) 75%,
      rgba(234, 46, 39, 1) 99%) !important;
}






._menu_list {
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-decoration: none;
  color: #3F4254;
  display: flex;
  align-items: center;
  position: relative;
  border: none;
  outline: none;
}

._menu_list__text {
  position: relative;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
}

._menu_list_color_orange[aria-current="page"] ._menu_list__text::after {
  content: "";
  display: block;
  height: 1.4px;
  width: 100%;
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%);
  margin-top: 0.2em;
  border-radius: 6px;
}

._menu_list_color_blue[aria-current="page"] ._menu_list__text::after {
  content: "";
  display: block;
  height: 1.4px;
  width: 100%;
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%);
  margin-top: 0.2em;
  border-radius: 6px;
}

._menu_list_color_familybook[aria-current="page"] ._menu_list__text::after {
  content: "";
  display: block;
  height: 1.4px;
  width: 100%;
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%);
  margin-top: 0.2em;
  border-radius: 6px;
}

._menu_list_color_ADANI[aria-current="page"] ._menu_list__text::after {
  content: "";
  display: block;
  height: 1.4px;
  width: 100%;
  background: linear-gradient(135deg, #0B74B0, #75479C, #BD3861);
  margin-top: 0.2em;
  border-radius: 6px;
}

._menu_list_color_GMR[aria-current="page"] ._menu_list__text::after {
  content: "";
  display: block;
  height: 1.4px;
  width: 100%;
  background: linear-gradient(135deg, #003974, #ed1c24, #faab53, #003974) !important;
  margin-top: 0.2em;
  border-radius: 6px;
}

._menu_list_color_VARDHMAN[aria-current="page"] ._menu_list__text::after {
  content: "";
  display: block;
  height: 1.4px;
  width: 100%;
  background: radial-gradient(circle, rgba(233, 237, 242, 1) 5%, rgba(5, 130, 59, 1) 100%, rgba(216, 219, 227, 1) 60%) !important;
  margin-top: 0.2em;
  border-radius: 6px;
}

._menu_list_color_PARLE[aria-current="page"] ._menu_list__text::after {
  content: "";
  display: block;
  height: 1.4px;
  width: 100%;
  background: linear-gradient(304deg, rgba(245, 235, 235, 1) 0%, rgba(245, 166, 166, 1) 30%, rgba(245, 70, 70, 1) 65%, rgba(245, 70, 70, 1) 16%, rgba(245, 70, 70, 1) 100%) !important;
  margin-top: 0.2em;
  border-radius: 6px;
}

._menu_list_color_GRANULES[aria-current="page"] ._menu_list__text::after {
  content: "";
  display: block;
  height: 1.4px;
  width: 100%;
  background: linear-gradient(135deg, #0098da 0%, #6fb9d6 30%, #f68a74 70%, #ffffff 100%) !important;
  margin-top: 0.2em;
  border-radius: 6px;
}


._menu_list_color_EMAMI[aria-current="page"] ._menu_list__text::after {
  content: "";
  display: block;
  height: 1.4px;
  width: 100%;
  background: linear-gradient(304deg,
      rgba(103, 57, 133, 1) 0%,
      rgba(75, 197, 228, 1) 25%,
      rgba(131, 201, 37, 1) 50%,
      rgba(252, 225, 2, 1) 75%,
      rgba(234, 46, 39, 1) 99%) !important;
  margin-top: 0.2em;
  border-radius: 6px;
}





.heading_of_txt_icon {
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #181c32;
  height: 20px;
}

.sub_list_txt {
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0%;
  color: #3f4254;
}

.cls_pointer {
  cursor: pointer;
}

/*.leftSideMEnu {
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #3f4254;
}*/
.menu-dot {
  display: inline-block;
  width: 3px;
  height: 3px;
  border-radius: 14px;
  background: #e4e6ef;
  vertical-align: middle;
  transition: background 0.2s;
}

.menu-dot.active {
  background: #A6AFFF;
}

/* Gradient dots for different hosts */
._menu_list_color_blue .menu-dot.active,
._menu_list_color_blue + .menu-dot.active {
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%);
}

._menu_list_color_orange .menu-dot.active,
._menu_list_color_orange + .menu-dot.active {
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%);
}

._menu_list_color_familybook .menu-dot.active,
._menu_list_color_familybook + .menu-dot.active {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%);
}

.menu-item-selected {
  color: #4318FF !important;
}

.menu-item-selected .menu-dot {
  background: #1976d2 !important;
}

.menu-item-selected .menu-name-selected {
  color: #4318FF !important;
}

.menu-name-selected {
  color: #1976d2 !important;
  font-weight: 600;
}

.v-menu__content,
.v-menu__content .v-card,
.v-menu__content .v-sheet {
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12) !important;
}

.sidebar-menu-dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #7E8299;
  flex-shrink: 0;
}

.sidebar-menu-dot-active {
  background: linear-gradient(90deg, #3982DB 0%, #8953ED 100%);
}

/* Starr selected dot */
.sidebar-selected-starr .sidebar-menu-dot-active {
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%);
}

/* Board selected dot */
.sidebar-selected-board .sidebar-menu-dot-active {
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%);
}

/* Familybook selected dot */
.sidebar-selected-familybook .sidebar-menu-dot-active {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%);
}

.sidebar-menu-item::before {
  background-color: transparent !important;
}

.sidebar-menu-item.v-list-item--active::before {
  opacity: 0 !important;
}

.sidebar-menu-text-wrapper {
  display: inline-block;
}

.sidebar-menu-item:hover .sub_list_txt:not(.sidebar-menu-child-selected) {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

.sidebar-menu-item:hover .sidebar-menu-dot:not(.sidebar-menu-dot-active) {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%) !important;
}

/* Starr hover styles */
.sidebar-selected-starr.sidebar-menu-item:hover .sub_list_txt:not(.sidebar-menu-child-selected) {
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

.sidebar-selected-starr.sidebar-menu-item:hover .sidebar-menu-dot:not(.sidebar-menu-dot-active) {
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%) !important;
}

/* Board hover styles */
.sidebar-selected-board.sidebar-menu-item:hover .sub_list_txt:not(.sidebar-menu-child-selected) {
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

.sidebar-selected-board.sidebar-menu-item:hover .sidebar-menu-dot:not(.sidebar-menu-dot-active) {
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%) !important;
}

.sidebar-menu-child-selected {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  font-weight: 500;
  position: relative;
  display: inline;
  padding-bottom: 4px;
}

/* Starr selected text */
.sidebar-selected-starr .sidebar-menu-child-selected {
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

/* Board selected text */
.sidebar-selected-board .sidebar-menu-child-selected {
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

.sidebar-menu-child-selected::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1.5px;
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%);
  border-radius: 2px;
}

/* Starr selected underline */
.sidebar-selected-starr .sidebar-menu-child-selected::after {
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%);
}

/* Board selected underline */
.sidebar-selected-board .sidebar-menu-child-selected::after {
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%);
}

.module-locked-text {
  opacity: 0.45;
  color: #9A96A8 !important;
}
</style>

<!-- Unscoped styles for popup menus (v-menu renders outside component) -->
<style type="text/css">
/* Popup menu item hover styles - Default (FamilyBook gradient) */
.v-menu__content .v-list-item:hover .sub_list_txt {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

.v-menu__content .v-list-item:hover .menu-dot {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%) !important;
}

/* Starr page hover styles */
body.starr-theme .v-menu__content .v-list-item:hover .sub_list_txt,
.starr-menu .v-menu__content .v-list-item:hover .sub_list_txt {
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

body.starr-theme .v-menu__content .v-list-item:hover .menu-dot,
.starr-menu .v-menu__content .v-list-item:hover .menu-dot {
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%) !important;
}

/* Board page hover styles (Orange gradient) */
body.board-theme .v-menu__content .v-list-item:hover .sub_list_txt,
.board-menu .v-menu__content .v-list-item:hover .sub_list_txt {
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

body.board-theme .v-menu__content .v-list-item:hover .menu-dot,
.board-menu .v-menu__content .v-list-item:hover .menu-dot {
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%) !important;
}

/* FamilyBook page hover styles (Blue-Purple gradient) */
body.familybook-theme .v-menu__content .v-list-item:hover .sub_list_txt,
.familybook-menu .v-menu__content .v-list-item:hover .sub_list_txt {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}

body.familybook-theme .v-menu__content .v-list-item:hover .menu-dot,
.familybook-menu .v-menu__content .v-list-item:hover .menu-dot {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%) !important;
}
</style>